import { render, staticRenderFns } from "./NButtonSaveOption.vue?vue&type=template&id=88035080&scoped=true&"
import script from "./NButtonSaveOption.vue?vue&type=script&lang=js&"
export * from "./NButtonSaveOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88035080",
  null
  
)

export default component.exports